import { useNavigate } from "react-router-dom";
import { useTimer } from "@/contexts/TimerContext";
import { fmtClock } from "@/lib/time";
import { Play, Pause, Square, AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";
import { toast } from "sonner";

// Persistent running-timer indicator shown in the app shell.
export function RunningTimerIndicator() {
  const t = useTimer();
  const navigate = useNavigate();
  if (!t || !t.timer.active) return null;
  const { timer, display, pause, resume, stop } = t;
  const warn = timer.long_timer_warning;

  return (
    <div data-testid="running-timer-indicator"
      className={cn("hidden items-center gap-2 rounded-full border px-2.5 py-1 md:flex",
        warn ? "border-warning bg-warning/10" : "border-accent/40 bg-accent-subtle")}>
      {warn && <AlertTriangle className="h-3.5 w-3.5 text-warning" title="This timer has been running a long time" />}
      <button onClick={() => navigate("/tasks/time")} className="max-w-[140px] truncate text-xs font-medium text-foreground" title={timer.task_title} data-testid="timer-task-link">
        {timer.task_title || "Tracking"}
      </button>
      <span className={cn("font-mono text-xs tabular-nums", timer.state === "running" ? "text-accent" : "text-muted-foreground")} data-testid="timer-elapsed">
        {fmtClock(display)}
      </span>
      {timer.state === "running" ? (
        <button onClick={async () => { await pause(); }} title="Pause" data-testid="timer-pause" className="text-muted-foreground hover:text-foreground"><Pause className="h-3.5 w-3.5" /></button>
      ) : (
        <button onClick={async () => { await resume(); }} title="Resume" data-testid="timer-resume" className="text-accent hover:opacity-80"><Play className="h-3.5 w-3.5" /></button>
      )}
      <button onClick={async () => { const r = await stop(); toast.success("Time saved"); }} title="Stop" data-testid="timer-stop" className="text-muted-foreground hover:text-destructive"><Square className="h-3.5 w-3.5" /></button>
    </div>
  );
}
